import { useTranslation } from 'react-i18next';
import { useDocumentParams } from 'app/router/params';
import { useState } from 'react';
import { FileZone } from 'app/components';
import { Loader } from 'app/components';
import moment from 'moment';
import { useXlsxFiles } from 'entities/reference-data';
import { useGetDocument, ReferenceDataValue } from 'entities/document';
import { useUser } from 'app/state/contexts/UserContext';
import { useReferenceList } from 'entities/reference-data';

interface FileEntry {
  revisionId: string;
  superId: string;
  filename: string;
  type?: string;
  createdAt: string;
}

interface FilesListReferenceData {
  isSuccess: boolean;
  fileSuperId?: string;
}

interface FilesListViewProps {
  onCloseClick: () => void;
  referenceData: FilesListReferenceData;
  onUploadSuccess: () => void;
}

export function FilesListView(props: FilesListViewProps) {
  const { t } = useTranslation('reference-data');

  const { onCloseClick, referenceData, onUploadSuccess } = props;
  const { documentId } = useDocumentParams();

  const [fileDetails, setFileDetails] = useState<FileEntry | null>();

  const { selectedOrganization } = useUser();
  const { data: document } = useGetDocument(documentId, selectedOrganization);
  const referenceList = useReferenceList(document);
  const xlsxFiles = useXlsxFiles(documentId);

  if (!xlsxFiles.isSuccess || !referenceData.isSuccess || !referenceList.isSuccess) {
    return <Loader />;
  }

  const setFile = (e: React.MouseEvent, file: FileEntry) => {
    e.stopPropagation();
    setFileDetails(file);
  };

  if (!!fileDetails) {
    return (
      <div className="detail-view reference-data">
        <div className="details--info">
          <div className="area--title">
            <div
              className="back"
              onClick={() => {
                setFileDetails(null);
              }}
            >
              <i className="fa-regular fa-chevron-left" />
            </div>
            <p>{fileDetails.filename}</p>
          </div>
          <div className="area--main">
            <dl className="description-list">
              <dt>{t('file.type')}</dt>
              <dd>{fileDetails.type}</dd>
              <dt>{t('file.filesize')}</dt>
              <dd>-</dd>
              <dt>{t('file.updated-by')}</dt>
              <dd>-</dd>
              <dt>{t('file.updated-at')}</dt>
              <dd>-</dd>
              <dt>{t('file.uploaded-by')}</dt>
              <dd>-</dd>
              <dt>{t('file.uploaded-at')}</dt>
              <dd>{moment(fileDetails.createdAt).format('YYYY-MM-DD HH:mm')}</dd>
            </dl>
            <h3>{t('file.used-in')}</h3>
            <div className="pill-box">
              {(referenceList.data as ReferenceDataValue[])
                .filter((reference) => reference.fileRevisionId === fileDetails.revisionId)
                .map((reference) => {
                  return (
                    <div className="pill" key={reference.revisionId}>
                      {reference.name}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  const sortedList = (xlsxFiles.data as FileEntry[]).sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  return (
    <div>
      <div className="detail-view reference-data">
        <div className="close-info-btn" onClick={onCloseClick}>
          <i className="fa-regular fa-xmark" />
        </div>
        <div>
          <div className="fs-3 py-r-1 px-r-1-25">{t('files.title')}</div>
          <div className="img-wrapper">
            <FileZone type="xlsx" documentId={documentId} onSuccess={onUploadSuccess} url={'/gaby/reference-data/xlsx'} />
          </div>
        </div>
        <div className="list">
          {sortedList.map((file) => (
            <div
              key={file.revisionId}
              className={`reference-item ${file.superId === referenceData?.fileSuperId && 'active-reference-item'}`}
              onClick={(e) => setFile(e, file)}
            >
              <div>
                <div className="file-details-item-wraper columns col-auto-1fr">
                  {file.superId === referenceData?.fileSuperId && <i className="fa-regular fa-link" />}
                  <p className="file-name">{file.filename}</p>
                </div>
                <p className="date-text">{moment(file.createdAt).format('D MMM. YYYY, HH:mm')}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
